import React, { useEffect, useRef, useState } from 'react';
import { FEATURE_LABEL } from './gbApi';

let scriptPromise = null;
const loadTerrain = () => {
  if (window.GBTerrain) return Promise.resolve(window.GBTerrain);
  if (!scriptPromise) {
    scriptPromise = new Promise((res, rej) => {
      const s = document.createElement('script');
      s.src = '/gb/terrain.js';
      s.onload = () => res(window.GBTerrain);
      s.onerror = rej;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
};
const loadImg = (src) => new Promise((res, rej) => {
  const i = new Image();
  i.onload = () => res(i);
  i.onerror = rej;
  i.src = src;
});

const superficie = (ctx, x, W, H) => {
  const col = ctx.getImageData(x, 0, 1, H).data;
  for (let y = 0; y < H; y++) if (col[y * 4 + 3] > 10) return y;
  return H;
};

// desenha o terreno REAL da fase (mesmo código e mesma semente da batalha)
export const GbTerrainPreview = ({ seed, features, map, node }) => {
  const ref = useRef(null);
  const [erro, setErro] = useState(false);
  const tier = (features || [])[0];

  useEffect(() => {
    let vivo = true;
    (async () => {
      try {
        const T = await loadTerrain();
        const cv = ref.current;
        if (!cv || !vivo) return;
        cv.width = 1600; cv.height = T.H;
        const c = cv.getContext('2d');
        const skin = T.SOIL[map] ? map : 'graveyard';
        const reg = T.regiao(node);
        const soil = await loadImg(`/${T.REGION_SOIL[reg] || T.SOIL[skin]}`);
        if (!vivo) return;
        c.clearRect(0, 0, 1600, T.H);
        T.render(c, {
          map: { pattern: c.createPattern(soil, 'repeat'), edge: T.REGION_EDGE[reg] || T.EDGE[skin] },
          W: 1600,
          features: features || [],
          seed: Number(seed) || 1,
        });
        const alvos = [200, 1400].map((x) => ({ x, y: superficie(c, x, 1600, T.H) }));
        const [fundo, tanque] = await Promise.all([loadImg(`/${T.BG[skin]}`), loadImg('/gb/world/tank.png')]);
        if (!vivo) return;
        c.globalCompositeOperation = 'destination-over';
        c.drawImage(fundo, 0, 0, 1600, T.H);
        c.globalCompositeOperation = 'source-over';
        alvos.forEach((a, i) => {
          const w = 92, h = 92 * (tanque.height / tanque.width);
          const topo = Math.min(a.y, T.H - 40) - h + 12;
          c.save();
          c.translate(a.x, 0);
          if (i === 1) c.scale(-1, 1);
          c.drawImage(tanque, -w / 2, topo, w, h);
          c.restore();
        });
      } catch (e) {
        if (vivo) setErro(true);
      }
    })();
    return () => { vivo = false; };
  }, [seed, features, map, node]);

  return (
    <div className="rounded-xl border border-purple-800/60 bg-black/40 p-3" data-testid="gb-sheet-terrain">
      <div className="flex items-center justify-between">
        <p className="text-purple-300/60">Terreno desta fase</p>
        <p className="text-[11px] font-bold text-amber-200">{FEATURE_LABEL[tier] || 'Solo completo'}</p>
      </div>
      <div className="mt-2 overflow-hidden rounded-lg border border-purple-900/70 bg-[#0b0712]">
        <canvas ref={ref} className="block h-auto w-full" data-testid="gb-terrain-canvas" />
      </div>
      <p className="mt-1 text-[10px] text-purple-300/60">
        {erro ? 'Não foi possível carregar a prévia agora.'
          : 'É exatamente o cenário que vai abrir na batalha — igual para os dois lados.'}
      </p>
    </div>
  );
};
